import {authHeaders, baseUrl, handleResponse} from "./apiUtils";

async function getProducts() {
  const response = await fetch(`${baseUrl}products`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function saveProduct(product) {
  const url = product.id ? `${baseUrl}products/${product.id}` : `${baseUrl}products`;
  const response = await fetch(url, {
    method: product.id ? "PUT" : "POST",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(product),
  });
  return handleResponse(response);
}

export default {
  getProducts,
  saveProduct,
};
